module.exports = __webpack_public_path__ + "images/program/eclairPixel.e493c1d7.svg";